/**
 * Returns a DiceBear initials avatar URL for a user.
 *
 * - Uses full name as the display seed so the correct initials are shown.
 * - Appends the email to the seed so two users with the same name get
 *   different background colors while keeping identical initials.
 * - Falls back to the email alone for invited/pending users who have not
 *   set a name yet.
 */
export function avatarUrl(firstName: string, lastName: string, email: string): string {
  // DiceBear initials uses the first and last *word* of the seed for the two initials.
  // It also discards anything after @ symbol, so we have to replace it in the email.
  // Inserting the email between firstName and lastName keeps the correct initials (first
  // letter of firstName + first letter of lastName) while making the color unique per user.
  let seed: string;
  if (firstName && lastName) {
    seed = `${firstName} ${email.replaceAll('@', 'AT')} ${lastName}`;
  } else if (firstName || lastName) {
    seed = firstName || lastName;
  } else {
    seed = email;
  }
  return `https://api.dicebear.com/9.x/initials/svg?seed=${encodeURIComponent(seed)}`;
}
